interface MarqueeProps {
  items: readonly string[]
  speed?: number
  reverse?: boolean
  variant?: 'solid' | 'outline'
}

export function Marquee({ items, speed = 60, reverse = false, variant = 'solid' }: MarqueeProps) {
  const classes = ['marquee', `marquee--${variant}`, reverse ? 'marquee--reverse' : '']
    .filter(Boolean)
    .join(' ')

  return (
    <div className={classes} aria-hidden="true">
      <div className="marquee__track" style={{ '--marquee-duration': `${speed}s` }}>
        {[0, 1].map((copy) => (
          <ul className="marquee__group" key={copy}>
            {items.map((item) => (
              <li className="marquee__item" key={item}>
                {item}
              </li>
            ))}
          </ul>
        ))}
      </div>
    </div>
  )
}
